/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptions interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptions(value) {
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptionsFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptionsFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AllowOnlyNewEmail': json['AllowOnlyNewEmail'] == null ? undefined : json['AllowOnlyNewEmail'],
    };
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptionsToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptionsToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AllowOnlyNewEmail': value['AllowOnlyNewEmail'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptions.js.map